import { objToList, objToLabelColorObj, listToObj } from 'utils/util'

// 申请时可选的信用类型list
export const CREDIT_TYPE_LIST = [
  {
    label: '信用限额',
    value: '1',
  },
  {
    label: '正常额度',
    value: '2',
  },
  {
    label: '临时额度',
    value: '3',
  },
  {
    label: '专项额度',
    value: '4',
  },
  {
    label: '信用限额 + 正常额度',
    value: '5',
  },
  {
    label: '信用限额 + 临时额度',
    value: '6',
  },
  {
    label: '信用限额 + 专项额度',
    value: '7',
  },
]

export const APPROVE_STATUS_OBJ = {
  1: {
    label: '审批中',
    color: 'blue',
  },
  2: {
    label: '审批通过',
    color: 'green',
  },
  3: {
    label: '审批否决',
    color: 'red',
  },
  4: {
    label: '已撤销',
    color: 'gray',
  },
}

export const APPROVE_STATUS_LIST = objToList(
  APPROVE_STATUS_OBJ,
  'text',
  'value',
)

export const APPROVE_STATUS_COLOR_OBJ = objToLabelColorObj(APPROVE_STATUS_OBJ)

export const MY_APPROVE_STATUS_OBJ = {
  1: {
    label: '通过',
    color: 'green',
  },
  2: {
    label: '不通过',
    color: 'red',
  },
}

export const MY_APPROVE_STATUS_LIST = objToList(
  MY_APPROVE_STATUS_OBJ,
  'text',
  'value',
)

// 信用类型的key-value对象
export const CREDIT_TYPE_OBJ = listToObj(CREDIT_TYPE_LIST)